// Buy Now: quick-buy button injected below Add to Cart on product pages (loaded from theme.liquid)
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('form[action*="/cart/add"][id^="product-form-"]');
    if (!form) return;
    if (document.getElementById('ring-builder-container')) return; // ring builder has its own draft-order checkout
    var atc = form.querySelector('.add-to-cart-btn');
    if (!atc) return;

    var style = document.createElement('style');
    style.textContent = '.buy-now-btn{width:100%;margin-top:10px;padding:18px;background:#B8965A;color:#fff;border:1px solid #B8965A;font-size:14px;font-weight:600;text-transform:uppercase;letter-spacing:.01em;cursor:pointer;transition:.3s ease}.buy-now-btn:hover{background:#a3824a;border-color:#a3824a}.buy-now-btn:disabled{background:#ccc;border-color:#ccc;cursor:not-allowed}.buy-now-error{color:#c62828;margin-top:8px;font-size:13px}';
    document.head.appendChild(style);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'buy-now-btn';
    btn.textContent = 'Buy Now';
    btn.disabled = atc.disabled;
    atc.insertAdjacentElement('afterend', btn);

    // mirror Add to Cart's disabled state when the variant changes
    new MutationObserver(function () {
      btn.disabled = atc.disabled;
    }).observe(atc, { attributes: true, attributeFilter: ['disabled'] });

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = 'Processing…';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = orig;
          var err = document.createElement('div');
          err.className = 'buy-now-error';
          err.textContent = 'Could not start checkout. Please try again.';
          btn.insertAdjacentElement('afterend', err);
          setTimeout(function () { err.remove(); }, 5000);
        });
    });
  });
})();
